import Default from './Default';

export default [function () {
    return angular.extend({}, Default.definition, {
        link: function link($scope) {
            $scope.rightAligned = true;
            if (typeof Default.definition.link === 'function') {
                return Default.definition.link.apply(this, arguments);
            }
        }
    });
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/propertyHeaders/table/RightAligned.js
// module id = 286
// module chunks = 0